import React from "react";
import { Grid, FormControl, InputLabel, Select, MenuItem, FormControlLabel, Switch } from "@material-ui/core";
import { AuthContext } from "../../../../shared/store/authProvider";
import { SubscriptionArray } from "../../../../shared/services/dataService";
import LayoutService from "../../../../shared/services/layoutService";
import { AgGridReact } from "ag-grid-react";
import { ResultStatus } from "../../../../shared/types/enums";
import FTPFolderService from "../ftpFolderService";
import PageLoadingComponent from "../../../../shared/components/page/pageLoadingComponent";
import PageErrorComponent from "../../../../shared/components/page/pageErrorComponent";
import DialogErrorFragmentComponent from "../../../../shared/components/page/dialogErrorFragmentComponent";

class InProgressFilesComponent extends React.Component {
    static contextType = AuthContext;
    oSubscriptions = new SubscriptionArray();
    STORE = FTPFolderService;
    constructor(props) {
        super(props);
        // init state
        this.state = {
            sourceSystemData: [],
            ftpFiles: [],
            modifiedFtpFileData: [],
            selectedSourceId: null,
            showArchiveFiles: false,
            sourceSystemsFetchResult: ResultStatus.NOT_LOADED,
            ftpFilesFetchResult: ResultStatus.NOT_LOADED,

        };
    }

    componentWillUnmount() {
        this.oSubscriptions.cancelAll();
    }

    componentDidMount() {
        this.fetchSourceSystems();
    }

    fetchSourceSystems = () => {
        this.oSubscriptions.cancelAll();
        this.setState({ sourceSystemsFetchResult: ResultStatus.LOADING, sourceSystemData: [] });

        const pageNumber = 1;
        const rowsPerPage = 250;

        this.oSubscriptions.add(
            this.STORE.getSourceSystems(this.context.user.tenantId, pageNumber, rowsPerPage).subscribe(
                (response) => {
                    this.setState({
                        sourceSystemData: response.filter(s => s.isFtpSource === 1),
                        sourceSystemsFetchResult: ResultStatus.SUCCESS
                    });
                },
                (error) => {
                    this.setState({ sourceSystemsFetchResult: ResultStatus.ERROR });
                    console.log(error);
                }
            ));
    };

    handleSourceChange = (event) => {
        const selectedSourceId = event.target.value;
        this.setState({ selectedSourceId });
        if (selectedSourceId) {
            this.fetchFTPFiles(selectedSourceId);
        }
    };

    getFtpFileData = (ftpFileData, showArchiveFiles) => {
        const filteredFiles = showArchiveFiles
            ? ftpFileData.filter((ftpFile) => ftpFile.fileName.toLowerCase().includes("-archive"))
            : ftpFileData.filter((ftpFile) => !ftpFile.fileName.toLowerCase().includes("-archive"));

        const sortedFiles = filteredFiles.slice().sort((a, b) => new Date(b.modifiedDate).getTime() - new Date(a.modifiedDate).getTime());
        return sortedFiles;
    }

    fetchFTPFiles = (sourceId) => {
        this.setState({ ftpFilesFetchResult: ResultStatus.LOADING, ftpFiles: [], modifiedFtpFileData: [] });
        this.STORE.getFTPFilesByTenantId(this.context.user.tenantId, sourceId).subscribe(
            (response) => {
                const ftpFileData = response;
                const modFtpFileData = (ftpFileData || []).map((data) => ({
                    ...data,
                    modifiedFileName: data.fileName.split('/').pop().split('.')[0],
                    modifiedDate: new Date(data.modifiedDate).toUTCString()
                }));

                const filteredFtpData = this.getFtpFileData(modFtpFileData, this.state.showArchiveFiles);

                this.setState({
                    ftpFiles: filteredFtpData,
                    modifiedFtpFileData: modFtpFileData,
                    ftpFilesFetchResult: ResultStatus.LOADED
                });
            },
            (error) => {
                console.log('Error fetching FTP Files:', error);
                this.setState({
                    ftpFilesFetchResult: ResultStatus.ERROR
                });
            }
        );
    };

    handleToggleChange = () => {
        this.setState({
            showArchiveFiles: !this.state.showArchiveFiles
        }, () => {
            const filteredFileData = this.getFtpFileData(this.state.modifiedFtpFileData, this.state.showArchiveFiles);
            this.setState({
                ftpFiles: filteredFileData
            });
        });
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
    };

    renderContent = (classes) => {
        switch (this.state.ftpFilesFetchResult) {
            case ResultStatus.LOADING: return <PageLoadingComponent small classes={classes} label="Loading Files..." />;
            case ResultStatus.LOADED:
                return (<div {...LayoutService.getAgGridStyles(240)}>
                    <AgGridReact
                        columnDefs={this.STORE.getColumnDefs(this)}
                        rowData={this.state.ftpFiles}
                        pagination={true}
                        paginationPageSize={50}
                        frameworkComponents={this.state.frameworkComponents}
                        gridOptions={{
                            tooltipShowDelay: 0,
                            context: { componentParent: this },
                            defaultColDef: { sortable: true }
                        }}
                        onGridReady={this.onGridReady}
                    ></AgGridReact>
                </div>);
            case ResultStatus.ERROR:
                return (<DialogErrorFragmentComponent classes={classes} description="An error occured while fetching files" onRetry={() => { this.fetchFTPFiles(this.state.selectedSourceId); }} />);
            default:
                return <></>;
        }
    }

    render() {
        const { classes } = this.props;
        //this.props.tabConfig.ref = this; // 1/4) required by parent component
        switch (this.state.sourceSystemsFetchResult) {
            case ResultStatus.NOT_LOADED:
            case ResultStatus.LOADING:
                return (<PageLoadingComponent classes={classes} label="Loading FTP Folders" />);
            case ResultStatus.SUCCESS:
                return (<>
                    <Grid container spacing={1} alignItems="center" style={{ paddingBottom: 16 }}>
                        <Grid item xs={6} sm={6}>
                            <FormControl style={{ minWidth: "90%" }} className={classes.dialogControl}>
                                <InputLabel id="source-system-label">Source System</InputLabel>
                                <Select fullWidth labelId="source-system-label" id="source-system" value={this.state.selectedSourceId}
                                    onChange={this.handleSourceChange}>
                                    {(this.state.sourceSystemData || []).map((system, idx) => (
                                        <MenuItem key={system.systemId} value={system.systemId}>{system.sourceLabel}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={6}>
                            <FormControlLabel control={
                                <Switch name="switchShowArchiveFiles" checked={this.state.showArchiveFiles} onChange={this.handleToggleChange}
                                    inputProps={{ "aria-label": "show archive files checkbox" }} />} label="Show Archive Files" />
                        </Grid>
                    </Grid>
                    {this.renderContent(classes)}

                </>);
            case ResultStatus.ERROR:
            default:
                return (
                    <PageErrorComponent label="Error Loading Source Systems" classes={classes} onRetry={() => { this.fetchData(true); }} />
                );
        }
    }
}

export default LayoutService.getHocComponenet(InProgressFilesComponent);
